import { useState } from 'react';
import { useNavigate, Link, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';

export default function LoginPage() {
  const { login, user, registrationOpen, loading } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);

  if (user && !loading) return <Navigate to="/" replace />;

  async function onSubmit(e) {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      await login(email, password);
      navigate('/');
    } catch (ex) {
      setErr(ex.message || 'Errore login');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth-card">
      <h1>Accedi</h1>
      {err && <div className="error">{err}</div>}
      <form onSubmit={onSubmit}>
        <div className="field">
          <label>Email</label>
          <input
            type="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="field">
          <label>Password</label>
          <input
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit" disabled={busy}>
          {busy ? 'Accesso…' : 'Entra'}
        </button>
      </form>
      {registrationOpen && (
        <p className="muted" style={{ marginTop: '1rem', textAlign: 'center' }}>
          Primo accesso? <Link to="/registrati">Registrati</Link>
        </p>
      )}
    </div>
  );
}
